<svg width="140" height="89" viewBox="0 0 140 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="88" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="9" y="12" width="124" height="65" rx="2" fill="#BBBFC3"/>
</svg>
